document.addEventListener('DOMContentLoaded', function () {
  bindCouponButtons(); 
});

function bindCouponButtons() {
  const couponButtons = document.querySelectorAll('.cart-coupon-button');

  couponButtons.forEach(button => {
    if (!button.dataset.originalText) {
  button.dataset.originalText = button.getAttribute('data-original-text') || button.textContent.trim();
}

    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (this.classList.contains('applied')) return;

      couponButtons.forEach(btn => {
        if (btn !== this) resetCouponButtonState(btn);
      });

      const discountCode = this.dataset.code;
      if (!discountCode) {
        console.error('No discount code found for this button.');
        return;
      }

      if (typeof gtag === 'function') {
        gtag('event', 'coupon_button_click', {
          'coupon_code': discountCode,
          'button_text': button.dataset.originalText
        });
      }

      button.textContent = 'Applying...';
      button.style.backgroundColor = '#6c757d';
      button.style.cursor = 'wait';
      button.disabled = true;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: discountCode })
      })
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then(cart => {
          if (cart.total_discount > 0 || (cart.original_total_price && cart.total_price < cart.original_total_price)) {
            button.textContent = 'Applied';
            button.classList.add('applied');
          } else {
            alert('Discount code could not be applied. Please check code or conditions.');
            resetCouponButtonState(button);
          }

          fetch('/cart.js')
            .then(response => response.json())
            .then(updatedCart => {
              updateCartDisplay(updatedCart);
            });

          fetch('/?sections=main-cart-items')
            .then(res => res.json())
            .then(data => {
              if (!data['main-cart-items']) return;

              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = data['main-cart-items'];

              const newContents = tempDiv.querySelector('.js-contents');
              const currentContents = document.querySelector('#main-cart-items .js-contents');

              if (newContents && currentContents) {
                currentContents.innerHTML = newContents.innerHTML;

                bindCouponButtons();
              }
            });
        })
        .catch(error => {
          console.error('Error applying discount:', error);
          alert('Failed to apply discount. Please try again.');
          resetCouponButtonState(button);
        });
    });
  });
}

function updateCartDisplay(cartData) {
  const formatMoney = (cents) => {
    let moneyFormat = (typeof window.theme !== 'undefined' && window.theme.moneyFormat)
      ? window.theme.moneyFormat
      : (window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}');

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    } else {
      return `$${(cents / 100).toFixed(2)} USD`;
    }
  };

  cartData.items.forEach(item => {
    const cartItemRow = document.querySelector(`.cart-item.js-cart-item[d-variant-id="${item.variant_id}"]`);
    if (cartItemRow) {
      const itemLineTotalElement = cartItemRow.querySelector('.cart-item-totals .price.price-end');
      if (itemLineTotalElement) {
        itemLineTotalElement.textContent = formatMoney(item.final_price * item.quantity);
      }
      const itemUnitPriceElement = cartItemRow.querySelector('.cart-item-details > .product-option');
      if (itemUnitPriceElement) {
        itemUnitPriceElement.textContent = formatMoney(item.final_price);
      }
    }
  });

  const cartTotalPriceElement = document.querySelector('.totals-subtotal-value');
  if (cartTotalPriceElement && typeof cartData.total_price !== 'undefined') {
    cartTotalPriceElement.textContent = formatMoney(cartData.total_price);
  }

  document.dispatchEvent(new CustomEvent('cart:updated', {
    bubbles: true,
    detail: { cart: cartData }
  }));
}

function resetCouponButtonState(button) {
  button.textContent = button.dataset.originalText;
  button.style.backgroundColor = '';
  button.style.cursor = 'pointer';
  button.disabled = false;
  button.classList.remove('applied');
}

if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}
if (typeof Shopify.formatMoney === 'undefined') {
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var formatString = (format || this.money_format || '${{amount}}');

    function defaultMoneyFormat(cents) {
      if (cents === null) return '';
      var sign = '';
      if (cents < 0) {
        sign = '-';
        cents = -cents;
      }
      var dollars = Math.floor(cents / 100);
      var cents = cents % 100;
      return sign + '$' + dollars + '.' + (cents < 10 ? '0' + cents : cents);
    }

    if (typeof formatString === 'function') {
      return formatString(cents);
    }

    if (formatString.includes('{{amount}}')) {
      value = formatString.replace('{{amount}}', defaultMoneyFormat(cents).replace('$', ''));
    } else {
      value = defaultMoneyFormat(cents);
    }

    return value;
  };
}
